module.exports = __webpack_public_path__ + "assets/img/800c-ht.svg";